import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Force reload and clear cache before rendering
const clearAllCache = () => {
  try {
    // Clear localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    
    // Disable browser cache
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  } catch (error) {
    console.log('Cache clear error:', error);
  }
};

// Clear cache before app starts
clearAllCache();

// Add no-cache headers dynamically
const addNoCacheHeaders = () => {
  const meta1 = document.createElement('meta');
  meta1.httpEquiv = 'Cache-Control';
  meta1.content = 'no-cache, no-store, must-revalidate';
  document.head.appendChild(meta1);
  
  const meta2 = document.createElement('meta');
  meta2.httpEquiv = 'Pragma';
  meta2.content = 'no-cache';
  document.head.appendChild(meta2);
  
  const meta3 = document.createElement('meta');
  meta3.httpEquiv = 'Expires';
  meta3.content = '0';
  document.head.appendChild(meta3);
};

addNoCacheHeaders();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);